import {Form} from "antd";
import React, {useEffect} from "react";
import DG_Form from "../../../../custom/data-entry/form";
import uuid from "react-uuid";
import Content from "../../weighing-station/content";

const Add = ({onCancel, onDatasource}) => {

    const [form] = Form.useForm()
    const key = uuid()
    const onFinish = (value) => {
        value ={
            ...value,
            status : value.status ? "active" : "inactive"
        }
        onDatasource(value)
        onCancel()
    }

    useEffect(()=>{
        form.setFieldsValue({key : key})
    },[])

    return (
        <>
            <DG_Form
                name="basic"
                labelCol={{span: 8}}
                wrapperCol={{span: 16}}
                autoComplete="off"
                form={form}
                mode={"add"}
                onFinish={onFinish}
                colon={false}
                labelAlign="left"
                scrollToFirstError={true}
            >
                <Content form={form} customer={false}/>

            </DG_Form>
        </>
    )
}

export default Add
